<script lang="ts">
  interface Props {
    count?: number;
  }

  let { count = 1 }: Props = $props();

  let items = $derived(Array(count));
</script>

<div class="comp-loader" data-cy="loader">
  {#each items as i}
    <div class="loader-i"></div>
  {/each}
</div>

<style>
  .comp-loader {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .comp-loader .loader-i {
    width: 100%;
    height: 10px;
    border-radius: 3px;
    background-color: #f9f9f9;
    position: relative;
    overflow: hidden;
  }
  .comp-loader .loader-i:not(:last-child) {
    margin-bottom: 16px;
  }

  .comp-loader .loader-i:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: inherit;
    filter: blur(2px);
    background-image: linear-gradient(90deg, #f9f9f9, #d8d8d8, #f9f9f9);
    background-color: white;
    animation: loading-slide 1.6s infinite ease-out;
    z-index: 0;
    opacity: 0.8;
  }

  @keyframes loading-slide {
    0% {
      left: -50%;
    }
    100% {
      left: 100%;
    }
  }
</style>
